import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Contact from './pages/Contact';
import translations from './i18n';
import { I18n, getClientLocale } from 'ceco-polyglot';
import AlertProvider from './context/AlertProvider';

export default function App() {
  const locale = getClientLocale({
    defaultLocale: 'es',
    locales: Object.keys(translations),
  });
  return (
    <AlertProvider>
      <I18n phrases={translations[locale]} locale={locale}>
        <Router>
          <Switch>
            <Route>
              <Contact />
            </Route>
          </Switch>
        </Router>
      </I18n>
    </AlertProvider>
  );
}
